import {GraphicRef, GraphicType, IGraphic} from '@mintdata/mint-kit/api/assets/Graphic';

export type IconName = string;
export type IconSvg = string;

export enum IconSize
{
    Size12 = 12,
    Size16 = 16,
    Size24 = 24,
    Size32 = 32,
    Size48 = 48,
    Size64 = 64,
}

export enum IconType
{
    Outline = 'outline',
    Glyph = 'glyph',
    Colored = 'colored',
}

export interface IIconFilters
{
    size:IconSize;
    type:IconType;
}

export class Icon implements IGraphic
{
    constructor(public name:IconName,
                public type:IconType,
                public size:IconSize,
                public availableSizes:IconSize[],
                public svg:IconSvg,
                public tags:string[])
    {
    }

    public getType():GraphicType
    {
        return GraphicType.Icon;
    }

    public getRef():GraphicRef
    {
        return new GraphicRef(this.name, this.getType());
    }

    public get nameWithoutSize():IconName
    {
        return this.name.split('-').slice(0, -1).join('-');
    }
}
